import React, { useState } from 'react';
import axios from 'axios';
import { useSiteConfig } from '../contexts/SiteConfigContext';
import { toast } from 'sonner';
import { Mail, Phone, MapPin, Send } from 'lucide-react';

const API_URL = process.env.REACT_APP_BACKEND_URL;

function ContactPage() {
  const { config } = useSiteConfig();
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    message: ''
  });
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      await axios.post(`${API_URL}/api/contact`, formData);
      toast.success('Mensaje enviado correctamente');
      setFormData({ name: '', email: '', message: '' });
    } catch (error) {
      console.error('Error sending message:', error);
      toast.error('Error al enviar el mensaje');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen py-24 px-4 sm:px-6 lg:px-8">
      <div className="max-w-5xl mx-auto">
        <div className="text-center mb-12">
          <h1 className="text-4xl sm:text-5xl font-light text-[#374963] mb-4" data-testid="contact-page-title">
            Contacto
          </h1>
          <p className="text-lg text-[#73706e]">
            ¿Tienes alguna pregunta? Estamos aquí para ayudarte.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
          {/* Contact Info */}
          <div className="space-y-8">
            <div className="flex items-start space-x-4">
              <div className="w-12 h-12 bg-[#374963] rounded-lg flex items-center justify-center flex-shrink-0">
                <Mail className="w-6 h-6 text-white" />
              </div>
              <div>
                <h3 className="text-lg font-semibold text-[#374963] mb-1">Email</h3>
                <p className="text-[#73706e]">{config?.contact_email || 'ton@kreeo.es'}</p>
              </div>
            </div>

            <div className="flex items-start space-x-4">
              <div className="w-12 h-12 bg-[#785534] rounded-lg flex items-center justify-center flex-shrink-0">
                <Phone className="w-6 h-6 text-white" />
              </div>
              <div>
                <h3 className="text-lg font-semibold text-[#374963] mb-1">Teléfono</h3>
                <p className="text-[#73706e]">{config?.contact_phone || '+34 123 456 789'}</p>
              </div>
            </div>

            <div className="flex items-start space-x-4">
              <div className="w-12 h-12 bg-[#374963] rounded-lg flex items-center justify-center flex-shrink-0">
                <MapPin className="w-6 h-6 text-white" />
              </div>
              <div>
                <h3 className="text-lg font-semibold text-[#374963] mb-1">Dirección</h3>
                <p className="text-[#73706e]">{config?.contact_address || 'Madrid, España'}</p>
              </div>
            </div>
          </div>

          {/* Contact Form */}
          <form onSubmit={handleSubmit} className="bg-white p-8 rounded-xl shadow-[0_8px_32px_rgba(0,0,0,0.04)]" data-testid="contact-form">
            <div className="space-y-6">
              <div>
                <label htmlFor="name" className="block text-sm font-medium text-[#374963] mb-2">
                  Nombre
                </label>
                <input
                  id="name"
                  name="name"
                  type="text"
                  value={formData.name}
                  onChange={handleChange}
                  required
                  className="w-full px-4 py-3 border border-[rgba(55,73,99,0.1)] rounded-lg focus:outline-none focus:ring-2 focus:ring-[#374963]"
                  data-testid="contact-name-input"
                />
              </div>

              <div>
                <label htmlFor="email" className="block text-sm font-medium text-[#374963] mb-2">
                  Email
                </label>
                <input
                  id="email"
                  name="email"
                  type="email"
                  value={formData.email}
                  onChange={handleChange}
                  required
                  className="w-full px-4 py-3 border border-[rgba(55,73,99,0.1)] rounded-lg focus:outline-none focus:ring-2 focus:ring-[#374963]"
                  data-testid="contact-email-input"
                />
              </div>

              <div>
                <label htmlFor="message" className="block text-sm font-medium text-[#374963] mb-2">
                  Mensaje
                </label>
                <textarea
                  id="message"
                  name="message"
                  value={formData.message}
                  onChange={handleChange}
                  required
                  rows={6}
                  className="w-full px-4 py-3 border border-[rgba(55,73,99,0.1)] rounded-lg focus:outline-none focus:ring-2 focus:ring-[#374963]"
                  data-testid="contact-message-input"
                />
              </div>

              <button
                type="submit"
                disabled={loading}
                className="w-full py-4 bg-[#785534] text-white rounded-lg hover:bg-[#8f6640] transition-colors disabled:opacity-50 flex items-center justify-center space-x-2"
                data-testid="contact-submit-button"
              >
                {loading ? (
                  <span>Enviando...</span>
                ) : (
                  <>
                    <Send className="w-5 h-5" />
                    <span>Enviar Mensaje</span>
                  </>
                )}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}

export default ContactPage;